import { apiAxiosCMS } from 'services/api';
import { TrainingProps } from 'types/TrainingProps';
import { getTrainings } from 'pages/ScreensTrainings/reqs';

export async function addTraining(
	dataForm: TrainingProps,
	setTraining: React.Dispatch<React.SetStateAction<TrainingProps[]>>,
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	trainings: TrainingProps[],
	handleNotify: any
) {
	setIsLoad(true);
	const payload: any = dataForm;

	delete payload.id;

	await apiAxiosCMS
		.post('/training', payload)
		.then(async () => {
			setTraining(await getTrainings(setIsLoad, handleNotify));
			handleNotify('Treinamento adicionado com sucesso!', 'success');
		})
		.catch(() => {
			setIsLoad(false);
			handleNotify(
				'Algum erro aconteceu ao tentar adicionar o treinamento.',
				'error'
			);
		});
}

function findPositionInList(list: TrainingProps[], id: string) {
	return list.findIndex((item) => item.id === id);
}

export async function editTraining(
	dataForm: TrainingProps,
	trainingToEdit: TrainingProps | null,
	setTraining: React.Dispatch<React.SetStateAction<TrainingProps[]>>,
	setIsLoad: React.Dispatch<React.SetStateAction<boolean>>,
	trainings: TrainingProps[],
	handleNotify: any
) {
	setIsLoad(true);
	const payload: any = dataForm;

	payload.position = findPositionInList(trainings, trainingToEdit?.id || '');
	delete payload.id;

	await apiAxiosCMS
		.patch(`training/${trainingToEdit?.id}`, payload)
		.then(async () => {
			setTraining(await getTrainings(setIsLoad, handleNotify));
			handleNotify('Treinamento editado com sucesso!', 'success');
		})
		.catch(() => {
			setIsLoad(false);
			handleNotify(
				'Algum erro aconteceu ao tentar editar o treinamentos.',
				'error'
			);
		});
}
